export const PICKUP_WINDOWS = ["Morning (8am–12pm)", "Afternoon (12–4pm)", "Evening (4–7pm)", "Overnight (7pm–8am)"];

export const openBooking = (payload) => {
  const d = btoa(unescape(encodeURIComponent(JSON.stringify(payload))));
  window.open(`/book?d=${encodeURIComponent(d)}`, "_blank", "noopener");
};

export const readBooking = (search) => {
  try {
    const d = new URLSearchParams(search).get("d");
    return d ? JSON.parse(decodeURIComponent(escape(atob(d)))) : null;
  } catch {
    return null;
  }
};
